/**
 * Handles s control action type.
 */
export enum HsControlActionType {
  None = 'None',
  Raycast = 'Raycast',
  ContextMenu = 'ContextMenu',
  LeftClick = 'LeftClick',
  MiddleClick = 'MiddleClick',
  RightClick = 'RightClick',
  Scroll = 'Scroll',
  Zoom = 'Zoom',
  LeftMove = 'LeftMove',
  MiddleMove = 'MiddleMove',
  RightMove = 'RightMove',

  MouseLeftPressed = 'MouseLeftPressed',
  MouseRightPressed = 'MouseRightPressed',
  MouseMiddlePressed = 'MouseMiddlePressed',

  PressedTop = 'PressedTop',
  PressedRight = 'PressedRight',
  PressedLeft = 'PressedLeft',
  PressedBottom = 'PressedBottom',
  PressedPlus = 'PressedPlus',
  PressedMinus = 'PressedMinus',
  PressedShift = 'PressedShift',
  PressedCtrl = 'PressedCtrl',
  PressedEscape = 'PressedEscape',
  PressedBackspace = 'PressedBackspace',

  PressedAdditionalOne = 'PressedAdditionalOne',
  PressedAdditionalTwo = 'PressedAdditionalTwo',

  CameraToolType = 'CameraToolType',
  CameraType = 'CameraType',
}
